module.exports = __webpack_public_path__ + "static/media/20-1.0bfb30c5.mp3";